import { Component, Host, h, Prop, Element } from '@stencil/core';

@Component({
  tag: 'spw-group',
  styleUrl: 'spw-group.scss',
  shadow: false,
})
export class SpwGroup {
  @Element() host: HTMLSpwGroupElement;

  /** Type d'éléments contenus dans le groupe (buttons, checkboxes, radios) */
  @Prop() type: 'buttons' | 'checkboxes' | 'radios' = 'buttons';
  /** Orientation du groupe (horizontal ou vertical) */
  @Prop() orientation: 'horizontal' | 'vertical' = 'horizontal';
  /** Alignement horizontal du groupe */
  @Prop() alignment: 'left' | 'center' | 'right' = 'left';
  /** Détermine si le groupe est désactivé */
  @Prop() disabled: boolean = false;
  /** Texte à afficher au-dessus de l'élément de formulaire */
  @Prop() label: string = '';
  /** Si `true`, le label comporte une astérisque */
  @Prop() required?: boolean;
  /** Attribut `name` de l'élément input */
  @Prop() name: string;

  private slotEl: HTMLSlotElement;

  componentDidLoad() {
    this.handleSlotChange();
  }

  private handleSlotChange = () => {
    const elements = this.slotEl?.assignedElements ? this.slotEl.assignedElements() : Array.from(this.host.querySelectorAll('*'));

    elements.forEach(element => {
      if (this.disabled) {
        element.setAttribute('disabled', '');
      } else {
        element.removeAttribute('disabled');
      }
    });
  };

  private get groupClasses(): { [key: string]: boolean } {
    return {
      'spw-group': true,
      'spw-group--horizontal': this.orientation === 'horizontal',
      'spw-group--vertical': this.orientation === 'vertical',
      'spw-group--disabled': this.disabled,
      [`spw-group--${this.type}`]: true,
      [`spw-group--align-${this.alignment}`]: true,
    };
  }

  render() {
    return (
      <Host>
        <div class={this.groupClasses}>
          {this.label && <spw-field-label class="spw-tw-mb-3" label={this.label} name={this.name} required={this.required}></spw-field-label>}
          <div class="spw-group__container">
            <slot ref={el => (this.slotEl = el as HTMLSlotElement)}></slot>
          </div>
        </div>
      </Host>
    );
  }
}
